import { render, staticRenderFns } from "./EntregaDocumentos.vue?vue&type=template&id=d66d3e5c"
import script from "./EntregaDocumentos.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d66d3e5c')) {
      api.createRecord('d66d3e5c', component.options)
    } else {
      api.reload('d66d3e5c', component.options)
    }
    module.hot.accept("./EntregaDocumentos.vue?vue&type=template&id=d66d3e5c", function () {
      api.rerender('d66d3e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/entregadocumentos/EntregaDocumentos.vue"
export default component.exports